module.exports = __webpack_public_path__ + "afd57618c393c4232698550e1076620c.mp4";